import * as React from "react";
import {useSelector} from "react-redux";
import moment from "moment";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {dateFormat, vasOptions} from "@/utils/constants";

import "./index.scss";

export default function VASCard(props) {
	const {element, handleEdit, handleDelete} = props;

	const userRole = useSelector((state) => state?.user?.roleName);
	const isPlayer = userRole === "Player";

	return (
		<div className="tqr-card-container">
			<div className="tqr-card-header">
				<div className="top-left">
					{moment(element.vasDate).format(dateFormat)}
				</div>
				<div className="top-right">
					{!isPlayer ? element.category?.name : undefined}
				</div>
			</div>
			<div className="tqr-card-info">
				<div className="info-title">
					<div className="tqr-info">
						{element.player
							? element.player.firstName + " " + element.player.lastName
							: "---"}
					</div>
				</div>
				<div className="info-subtitle">
					{vasOptions.filter((o) => o.value === element.vasValue)?.[0]?.label ||
						"Nessun dato inserito"}
				</div>
			</div>
			{!element.emptyRow && <div className="separator"></div>}
			{!element.emptyRow && (
				<div className="tqr-card-preview">
					<div className="tqr-actions">
						<div className="tqr-action" onClick={() => handleEdit(element)}>
							<EditIcon />
						</div>
						<div
							className="tqr-action error"
							onClick={() => handleDelete(element)}
						>
							<DeleteIcon />
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
